import { render, staticRenderFns } from "./LinkedinCallback.vue?vue&type=template&id=f5b9489c&"
import script from "./LinkedinCallback.vue?vue&type=script&lang=ts&"
export * from "./LinkedinCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports